export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11806.d3e91670.jpg";